import { useState, useEffect } from 'react';

export default function useUnmountWithDelay({ shouldBeMounted, delay = 300 }) {
  const [isMounted, setIsMounted] = useState(shouldBeMounted);

  useEffect(() => {
    if (shouldBeMounted) {
      setIsMounted(true);
    } else {
      const timer = setTimeout(() => {
        setIsMounted(false);
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [shouldBeMounted, delay]);

  return isMounted;
}
